<template>
	<modal :exibir="exibirModal" :max-width="500" class="modal-confirmacao" @close="cancelarAcaoModal">
		<template #title>
			<v-card-title class="d-flex justify-center mt-3 text-h5">
				<v-icon id="iconeModal" size="80" :color="corIcone" class="mb-2">{{ iconeModal }}</v-icon>
				<span class="texto-titulo">
					<b>{{ tituloModal }}</b>
				</span>
				<v-spacer></v-spacer>
			</v-card-title>
		</template>

		<template #body>
			<div v-if="exibirLista" class="listagem pa-5">
				<ul v-for="(campo, index) in mensagemLista" :key="index" class="mb-5">
					<li class="lista">{{ campo }}</li>
				</ul>
			</div>
			<v-row v-else dense class="az-form-content cp-modal-form-content justify-center mensagem-modal">
				<span class="texto-corpo">{{ mensagemModal }}</span>
				<h4 class="mt-2 texto-confirmacao">{{ mensagemConfirmacao }}</h4>
			</v-row>
		</template>

		<template #actions>
			<v-divider></v-divider>
			<v-card-actions class="d-flex justify-space-between pb-3 pt-3">
				<botao-salvar
					data-test="botao-salvar"
					:label="labelAcaoCancelar"
					style="max-width: 60px"
					:disabled="false"
					@salvar="cancelarAcaoModal"
				></botao-salvar>
				<botao-cancelar
					data-test="botao-cancelar"
					:label="labelAcaoConfirmar"
					style="max-width: 60px"
					@cancelar="confirmarAcaoModal"
				></botao-cancelar>
			</v-card-actions>
		</template>
	</modal>
</template>
<script>
import Modal from './Modal.vue'
import BotaoSalvar from './BotaoSalvar.vue'
import BotaoCancelar from './BotaoCancelar.vue'

export default {
	name: 'modal-confirmacao',
	components: {
		Modal,
		BotaoSalvar,
		BotaoCancelar,
	},
	props: {
		iconeModal: {
			type: String,
			default: 'mdi-alert-circle-outline',
		},
		corIcone: {
			type: String,
			default: '#FF9900',
		},
		exibirModal: {
			type: Boolean,
			required: true,
		},
		labelAcaoConfirmar: {
			type: String,
			default: 'Sim',
		},
		labelAcaoCancelar: {
			type: String,
			default: 'Não',
		},
		mensagemConfirmacao: {
			type: String,
			default: 'Deseja realmente confirmar esta ação?',
		},
		mensagemModal: {
			type: String,
			default: '',
		},
		tituloModal: {
			type: String,
			required: true,
		},
		exibirLista: {
			type: Boolean,
		},
		mensagemLista: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		cancelarAcaoModal() {
			this.$emit('cancelar-acao')
		},
		confirmarAcaoModal() {
			this.$emit('confirmar-acao')
		},
	},
}
</script>

<style scoped>
.v-dialog .texto-titulo {
	color: #404040;
	width: 98%;
	text-align: center;
	margin-left: 18px;
	margin-right: 17px;
	font-weight: 700;
	font-size: 22px;
	line-height: 26px;
}

.v-dialog .close-modal-mobile {
	position: absolute !important;
	right: 20px !important;
}

.mensagem-modal {
	display: grid !important;
}

.v-dialog .v-card__title {
	word-break: break-word;
}

.texto-corpo {
	color: #4B4B4B;
	font-size: 18px;
	font-weight: 400;
	text-align: center;
	font-style: normal;
	line-height: 25px;
}

.texto-confirmacao {
	color: #726f6f;
	font-size: 18px;
	font-weight: 400;
	text-align: center;
	font-style: normal;
	line-height: 25px;
}

.lista {
	list-style: circle;
}

.listagem {
	max-height: 350px;
}
</style>
